// extracted by mini-css-extract-plugin
export var section = "infoText-module--section--3qdEc layout-module--section--80yNc";